import { buildCreateSlice, asyncThunkCreator } from '@reduxjs/toolkit';

import { initialState } from './initial';
import { reducers } from './reducers';

export const createAppSlice = buildCreateSlice({
  creators: { asyncThunk: asyncThunkCreator },
});

export const connectedAdmins = createAppSlice({
  name: 'connected-admins',
  initialState,
  reducers,
});

export const { setConnectedAdmins, addConnectedAdmin, removeConnectedAdmin } = connectedAdmins.actions;

export default connectedAdmins.reducer;
